/*
 * @Author: N0ts
 * @Date: 2022-11-18 11:41:45
 * @Description: 配置
 * @FilePath: /vue/src/config/config.ts
 * @Mail：mail@n0ts.top
 */

export default {
    // 码云第三方应用配置
    gitee: {
        clientId:
            "c41beff69a847a4ee82b1c0db28fa70ada5aa4f6546543ebee70e284dd992deb",
        clientSecret:
            "90fc5270dd78bf9d709bd31033134933c572f6e3b513aef9ffed89af6e687bc7",
        scope: "projects user_info",
        redirectUri: "https://search.n0ts.top/"
    }
};
